/* eslint-disable header/header */
export const name = "@azure/msal-browser-1p";
export const version = "4.28.2";
